export default __webpack_public_path__ + "static/media/no-emails-yet.287eae9a.svg";